import { get } from '@/libs/http';
import type { ChangeCheckRes } from '@/types/api/message/change-check';

/**
 * Request counter for change-check API
 * Increments with each request as required by the API
 */
let requestCounter = 0;

/**
 * Get change check status
 * @param isPolling - Whether this is a polling request
 */
export const getChangeCheck = (isPolling?: boolean) => {
  requestCounter++;
  return get<ChangeCheckRes>('/message/v1/change-check', {
    params: { num: requestCounter },
    isPollingRequest: !!isPolling,
  } as any);
};
